import { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { motion, useInView, AnimatePresence } from "framer-motion";

function Top() {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("SLNToken");
    localStorage.removeItem("SLNUserDetails");
    navigate("/", { replace: true });
  };

  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("SLNToken");
    const stored = localStorage.getItem("SLNUserDetails");

    if (stored) {
      try {
        setUserDetails(JSON.parse(stored));
      } catch {
        setUserDetails(null);
      }
    }

    if (!token) return;

    try {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      const userId = decoded.userId || decoded.id || decoded.sub;

      fetch(
        `https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Profile/GetUserProfile?userId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      )
        .then((res) => res.json())
        .then((data) => {
          localStorage.setItem("SLNUserDetails", JSON.stringify(data));
          setUserDetails(data);
        })
        .catch((err) => console.error("User fetch error:", err));
    } catch (err) {
      console.error("Token decode error:", err);
    }
  }, []);

  return (
    <>
      {/* ── Ticker Banner ─────────────────────────────────────────────────── */}
      <div
        className="d-flex justify-content-center align-items-center position-relative overflow-hidden"
        style={{
          background:
            "linear-gradient(90deg, #1a0800 0%, #2e1200 30%, #3a1800 50%, #2e1200 70%, #1a0800 100%)",
          height: 44,
        }}
      >
        <div className="container d-flex justify-content-between align-items-center position-relative overflow-hidden">
          <div className="d-flex align-items-center">
            {/* shimmer sweep */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "60%",
                height: "100%",
                background:
                  "linear-gradient(90deg,transparent,rgba(255,160,30,0.07),transparent)",
                pointerEvents: "none",
              }}
            />

            {/* Verified tag */}
            <span
              style={{
                background: "linear-gradient(135deg,#FF8C00,#E06400)",
                borderRadius: 3,
                padding: "2px 10px",
                fontSize: 9.5,
                fontWeight: 800,
                letterSpacing: "0.14em",
                color: "#1a0800",
                textTransform: "uppercase",
                marginRight: 18,
                flexShrink: 0,
                boxShadow: "0 0 12px rgba(255,140,0,0.35)",
              }}
            >
              ✦ Verified
            </span>

            {[
              "SEBI-Trained Mentor",
              "ISO Certified Institute",
              "Startup India Recognised",
            ].map((label, i) => (
              <div
                key={label}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 7,
                  padding: "0 16px",
                  whiteSpace: "nowrap",
                }}
              >
                {i > 0 && (
                  <div
                    style={{
                      width: 1,
                      height: 18,
                      background:
                        "linear-gradient(to bottom,transparent,rgba(255,140,0,0.35),transparent)",
                      flexShrink: 0,
                      marginRight: 16,
                    }}
                  />
                )}
                <span
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    border: "1.5px solid rgba(255,140,0,0.5)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    background: "rgba(255,140,0,0.1)",
                  }}
                >
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <path
                      d="M1.5 4L3.2 5.8L6.5 2.2"
                      stroke="#FF8C00"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    letterSpacing: "0.05em",
                    color: "#FF8C00",
                  }}
                >
                  {label}
                </span>
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-end align-items-center">
            <img
              src="/assets/images/nse.png"
              height="35"
              className="bg-white px-3 py-2 rounded-pill me-1"
            />
            <img
              src="/assets/images/iso.png"
              height="35"
              className="bg-white px-2 py-2 rounded-pill me-1"
            />
            <img
              src="/assets/images/startup-india.png"
              height="35"
              className="bg-white rounded-pill"
            />
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg py-0 px-0 my-header-bg sticky-top z-5">
        <div className="container">
          <div className="d-flex align-items-center">
            <button
              class="navbar-toggler collapsed me-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="icon-bar top-bar mt-0"></span>
              <span class="icon-bar middle-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>

            <Link to="/">
              <img
                src="/assets/images/logo.png"
                className="d-lg-none d-block"
                width="50"
              />
              <img
                src="/assets/images/logo.png"
                width="50"
                className="me-5 d-lg-block d-none"
              />
            </Link>
          </div>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-1 align-items-center justify-content-end me-lg-5 me-2">
                  <a
                    href="https://www.facebook.com/profile.php?id=61586179350665"
                    target="_blank"
                  >
                    <img src="/assets/images/facebook.png" width="30" />
                  </a>
                  <img src="/assets/images/instagram.png" width="30" />
                  <a href="https://x.com/AcademySln64983" target="_blank">
                    <img src="/assets/images/x.png" width="30" />
                  </a>
                  <a
                    href="https://www.youtube.com/@SLNAcademyOfficial"
                    target="_blank"
                  >
                    <img src="/assets/images/youtube.png" width="30" />
                  </a>
                </div>
                <Link
                  to="/cart"
                  class="btn btn-icon btn-success rounded-circle d-none d-md-inline-flex ms-2"
                >
                  <i class="bi bi-cart-dash-fill fs-4 align-middle"></i>
                </Link>

                <div className="header-btn-height ms-1">
                  <div
                    onClick={handleLogout}
                    className="cursor-pointer bg-gradient-blue text-white fw-normal rounded-pill px-3 h-100 d-flex align-items-center"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="fs-7 d-flex align-items-center">
                        <i className="bi bi-person-circle me-2 fs-3"></i> Logout
                      </div>
                      <i className="bi bi-power fs-4 ms-5"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0">
              <li class="nav-item">
                <Link class="nav-link" to="/dashboard">
                  Dashboard
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/enrolled-courses">
                  Enrolled Courses
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/payments">
                  Payments
                </Link>
              </li>
              {userDetails?.slnAccess === true && (
                <li className="nav-item">
                  <Link className="nav-link" to="/sln-scan-live">
                    SLN Scan{" "}
                    <span className="badge bg-danger ms-2 rounded-pill px-3">
                      Live
                    </span>
                  </Link>
                </li>
              )}
              <li class="nav-item">
                <Link class="nav-link" to="/settings">
                  Settings
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Top;
